import React from 'react'
import StaticCmsPage from '../../components/nemonto/StaticCmsPage'

const PrivacyPolicy = () => (
    <StaticCmsPage slug="privacy-policy" title="Privacy Policy" subtitle="How we collect, use, and protect your information." />
)

export default PrivacyPolicy
